import { store } from "../redux/store";
import {
  mergeUserProfile as mergeUserProfileAction,
  setSessionProfile as setSessionProfileAction,
} from "../redux/profileSlice";

const isPlainObject = (value) => {
  if (!value || typeof value !== "object") return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

const extractProfiles = (payload) => {
  if (!payload || typeof payload !== "object") return {};

  // Common shapes in this app:
  // - direct backend JSON: { session_profile, user_profile, ... }
  // - wrapped: { fastapi_response: { ...profiles } }
  // - SSE done: { result: { ...profiles } }
  const direct = payload;
  const fastapi = isPlainObject(payload.fastapi_response) ? payload.fastapi_response : null;
  const result = isPlainObject(payload.result) ? payload.result : null;

  const candidates = [direct, fastapi, result].filter(Boolean);

  for (const obj of candidates) {
    const hasSession = Object.prototype.hasOwnProperty.call(obj, "session_profile");
    const hasUser = Object.prototype.hasOwnProperty.call(obj, "user_profile");
    if (hasSession || hasUser) {
      return {
        session_profile: hasSession ? obj.session_profile : undefined,
        user_profile: hasUser ? obj.user_profile : undefined,
      };
    }
  }

  return {};
};

export const setSessionProfile = (sessionProfile) => {
  store.dispatch(setSessionProfileAction(sessionProfile ?? null));
};

export const mergeUserProfile = (userProfile) => {
  if (!userProfile || typeof userProfile !== "object") return;
  store.dispatch(mergeUserProfileAction(userProfile));
};

export const syncProfilesFromResponse = (responsePayload) => {
  const { session_profile, user_profile } = extractProfiles(responsePayload);

  // 1) session_profile: always replace when present
  if (session_profile !== undefined) {
    setSessionProfile(session_profile);
  }

  // 2) user_profile: merge when present
  if (user_profile !== undefined) {
    mergeUserProfile(user_profile);
  }

  return { session_profile, user_profile };
};
